import { FC } from 'react';
import { IndicatorIndexedPath } from '../indicator-config-form.utils';
import { TradingFormField } from '../../trading-form-field';
import { LiquidationIndicatorMode } from '@shared/types';

type LiquidationFieldsProps = {
  path: IndicatorIndexedPath;
};

export const LiquidationFields: FC<LiquidationFieldsProps> = ({ path }) => {
  return (
    <>
      <TradingFormField
        type="numeric"
        name={`${path}.zigZag.deviationThreshold`}
        label="Deviation Threshold"
      />
      <TradingFormField
        type="numeric"
        name={`${path}.zigZag.depth`}
        label="Depth"
      />
      <TradingFormField
        type="autocomplete"
        name={`${path}.mode`}
        label="Mode"
        options={Object.values(LiquidationIndicatorMode)}
        defaultValue={LiquidationIndicatorMode.LIQUIDATION}
      />
      <TradingFormField
        type="numeric"
        name={`${path}.pivotLookback`}
        label="Pivot lookback"
      />
      <TradingFormField
        type="numeric"
        name={`${path}.reclaimWithinCandles`}
        label="Reclaim within candles"
      />
      <TradingFormField
        type="numeric"
        name={`${path}.confirmationCandles`}
        label="Confirmation candles"
      />
      <TradingFormField
        type="autocomplete"
        name={`${path}.confirmationInvalidationMode`}
        label="Invalidation mode"
        options={['CLOSE', 'WICK']}
      />
      <TradingFormField
        type="numeric"
        name={`${path}.minBreakPercent`}
        label="Min break %"
      />
      <TradingFormField
        type="numeric"
        name={`${path}.minReactionPercent`}
        label="Min reaction %"
      />
      <TradingFormField
        type="checkbox"
        name={`${path}.visualization.showLines`}
        label="Show lines"
      />
      {/* Keep visibility in indicator form state so template/layout snapshot
          can restore this without relying on external uiState maps. */}
      <TradingFormField
        type="checkbox"
        name={`${path}.visualization.showZigZag`}
        label="Show zig-zag"
      />
    </>
  );
};
